import mutationTypes from './mutation-types'

export default {
  [mutationTypes.SET_OFFER_MEAL] (state, payload) {
    state.offerMeal = payload;
  },
  [mutationTypes.SET_SOLD_OUT] (state, payload) {
    state.soldOut = payload;
  },
  [mutationTypes.SET_UPDATED_OFFER_MEAL_ID] (state, payload) {
    state.updatedOfferMealId = payload;
  },
  [mutationTypes.SET_VISIBLE] (state, payload) {
    state.visible = payload;
  },
  [mutationTypes.SET_PRICE_FORMATTED] (state, payload) {
    state.priceFormatted = payload;
  },
  [mutationTypes.SET_VALID] (state, payload) {
    state.valid = payload;
  },
  [mutationTypes.SET_ERRORS] (state, payload) {
    state.errors = payload;
  },
  [mutationTypes.SET_PACKAGING_PRICE_FORMATTED] (state, payload) {
    state.packagingPriceFormatted = payload;
  }
}
